import React from 'react';
import invariant from 'tiny-invariant';
import { isBrowser } from '../../utils';
import { createMediaQuery } from './create-media-query';
import { useMediaQueryListener } from './use-media-query-listener';
export const useMediaQuery = (query, options = {}) => {
  const {
    defaultMatches = null
  } = options;
  const supportsMatchMedia = isBrowser() && 'matchMedia' in window;
  const parsedMediaQuery = createMediaQuery(query);

  if (!supportsMatchMedia && isBrowser()) {
    invariant(false, "matchMedia isn't supported in your browser\n" + 'Please, use related polyfill or different implementations');
  }

  const [match, setMatch] = React.useState(() => {
    if (supportsMatchMedia && isBrowser()) {
      return window.matchMedia(parsedMediaQuery).matches;
    }

    return defaultMatches;
  });
  useMediaQueryListener(parsedMediaQuery, event => setMatch(event.matches));
  return match;
};